import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Input } from '../models/input';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-eixo-tecnologico',
  templateUrl: './eixo-tecnologico.component.html',
  styleUrls: ['./eixo-tecnologico.component.scss'],
})
export class EixoTecnologicoComponent implements OnInit {
  cursos: any[];
  eixo: any;
  eixos: any;
  // deslocamento = 0; // descolamento de página
  paginaAtual: number;
  totalPaginas: number;
  encurtarTexto = true;
  mostrarAreasTecnologicas: boolean;
  mostrarCursos: boolean;
  mostrarCursosArea: boolean;
  msgSemArea: string;
  mostrarMsgSemArea = false;
  areasTecnologicas = [];
  eixoId: number;
  realizouBusca = false;
  totalResultados = 0;
  componenteRef = 'cursos';
  error: boolean;
  inscricao: Subscription;

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const {
        cursos: { itens, paginaAtual, totalPaginas, totalItens },
        eixo,
        eixos,
        areas,
        eixoError,
        eixosError,
        cursosError,
        areasError,
      } = data;

      this.error = eixoError !== undefined
        || eixosError !== undefined
        || cursosError !== undefined
        || areasError !== undefined ? true : false;

      if (!this.error) {
        this.eixo = eixo;
        this.eixos = eixos;
        this.cursos = itens;
        this.areasTecnologicas = areas;
        this.paginaAtual = paginaAtual;
        this.totalPaginas = totalPaginas;
        this.totalResultados = totalItens;
        this.mostrarCursos = true;
        this.mostrarAreasTecnologicas = false;

        if (this.areasTecnologicas.length === 0) {
          this.msgSemArea = 'Este Eixo não possui divisão em áreas tecnológicas.';
        }
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.mostrarCursosArea = params && params.mostrarCursosArea !== undefined && params.mostrarCursosArea === 'true' ? true : false;
      if (!!this.mostrarCursosArea) {
        this.mostrarCursos = false;
        this.mostrarAreasTecnologicas = true;
      }
    });
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/eixo-tecnologico'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }

  /**
   *
   */
  showAreasTecnologicas() {
    if (!this.msgSemArea) {
      this.mostrarCursos = false;
      this.mostrarCursosArea = false;
      this.mostrarAreasTecnologicas = true;
      this.router.navigate(['eixo-tecnologico'], {
        queryParamsHandling: 'merge',
      });
    } else {
      this.mostrarMsgSemArea = true;
      this.mostrarCursos = true;
    }
  }

  recebeuInput(input: Input) {
    this.realizouBusca = true;
    this.router.navigate(['/eixo-tecnologico'], {
      queryParamsHandling: 'merge',
      queryParams: {
        query: input.stringBusca
      },
    });
  }

  showCursosAreas(dados: any) {
    this.mostrarCursosArea = true;
    this.mostrarAreasTecnologicas = false;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['cursos', 'area'], {
        queryParamsHandling: 'merge',
        queryParams: {
          eixo: dados.eixo,
          areatecnologica: dados.areatecnologica,
          // cursosArea: this.mostrarCursosArea
        },
      });
    });
  }
}
